<template>
    <div class="custom_pull_down">
        <div class="pull_down_wrapper" @click="toggleAccordion">
            <div class="select">
                <div class="caption">
                    {{caption}}
                </div>
                <div class="arrow" :class="{open: is_open}">▼</div>
            </div>
            <div class="accordion" :class="{open: is_open}">
                <div
                        class="item"
                        v-for="(item, i) in items"
                        :key="i"
                        @click.stop
                >
                    <input type="checkbox" :id="`${id}-${item}`" :value="item" v-model="check_input">
                    <label :for="`${id}-${item}`">{{item.replace('床色：', '')}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'

    export default {
        name: "CustomPullDown",
        props: {
            caption: String,
            items: Array,
            checked_items: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            id: `input-${uuidv4()}`,
            checked: [],
            is_open: false
        }),
        computed: {
            check_input: {
                get() {
                    return this.checked;
                },
                set(value) {
                    this.checked = value;
                    this.$emit('change', value)
                }
            }
        },
        created() {
            this.checked = [...this.checked_items];
        },
        watch: {
            checked_items() {
                this.checked = [...this.checked_items];
            }
        },
        methods: {
            toggleAccordion() {
                this.is_open = !this.is_open
            }
        }
    }
</script>

<style scoped lang="scss">

    .custom_pull_down{
        user-select: none;
        cursor: pointer;
        .pull_down_wrapper{
            position: relative;
            color: #826E67;
            font-size: 15px;
            width: 200px;
            height: 45px;
            display: flex;
            background-color: #EADCDC;
            align-items: center;
            border: solid 2px #826E67;
            border-radius: 5px;
            box-sizing: border-box;
            .select{
                display: flex;
                align-items: center;
                width: 100%;
                height: 100%;
                padding: 0 0.75rem;
                border-radius: 5px;
                background-color: #EADCDC;
                &:hover{
                    background-color: #f1e3e3;
                }
                .caption{
                    flex-grow: 1;
                    text-align: center;
                }
                .arrow{
                    width: 18px;
                    font-size: 18px;
                    transition: 0.3s ease-in-out;
                    &.open{
                        transform: scaleY(-1);
                    }
                }
            }
            .accordion{
                z-index: 99999;
                position: absolute;
                bottom: 2px;
                left: -2px;
                right: -2px;
                transform: translateY(100%);
                visibility: hidden;
                max-height: 0;
                transition: 0.3s ease-in-out;
                overflow: hidden;
                background-color: white;
                border: solid 2px #826E67;
                border-radius: 0 0 5px 5px;
                border-top: none;
                .item{
                    padding: 0.5rem 1rem;
                    font-size: 13px;
                    &:not(:last-child){
                        border-bottom: dotted 2px #EADCDC;
                    }
                }
                .item input[type="checkbox"]{
                    display: none;
                }
                .item input[type="checkbox"]+label{
                    display: none;
                    cursor: pointer;
                    display: inline-block;
                    position: relative;
                    padding-left: 25px;
                    padding-right: 10px;
                }
                .item input[type="checkbox"]+label::before{
                    content: "";
                    position: absolute;
                    display: block;
                    box-sizing: border-box;
                    width: 13px;
                    height: 13px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    border: 1px solid;
                    border-radius: 25%;
                    border-color:  #826e67;
                }
                .item input[type="checkbox"]:checked+label::after{
                    content: "";
                    position: absolute;
                    display: block;
                    box-sizing: border-box;
                    width: 8px;
                    height: 8px;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    left: calc(13px / 2);
                    border: 3px solid;
                    border-radius: 30%;
                    border-color:  #c08c8b;
                    background-color: #c08c8b;
                }

                label {
                    width: 100%;
                    /*background: #00CC00;*/
                }
            }
            .accordion.open{
                visibility: visible;
                max-height: 200vh;
            }

        }
    }
</style>
